import React, { useEffect } from "react";
import { connect } from "react-redux";
import DisplayBuildings from "./DisplayBuildings";
import NoBuildings from "./NoBuildings";
import AddBuildings from "./AddBuildings";
import { app } from "../../constants/config";
import { fetchingBuildings } from "../../actions/buildingActions";

const Buildings = (props) => {
  useEffect(() => {
    FetchingBuildings();
  }, []);

  const FetchingBuildings = () => {
    fetch(`${app}/building/get`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${props.banker.token}`,
      },
      body: JSON.stringify({
        fromDate: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          1
        ).getTime(),
        toDate:
          new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            1
          ).getTime() +
          1000 *
            60 *
            60 *
            24 *
            new Date(
              new Date().getFullYear(),
              new Date().getMonth(),
              0
            ).getDate(),
        month: `${new Date().getFullYear()}-${(
          "0" +
          (new Date().getMonth() + 1)
        ).slice(-2)}`,
      }),
    })
      .then((res) => res.json())
      .then((details) => {
        if (details.code == 2) {
        } else {
          props.fetchingBuildings(details);
        }
      })
      .catch((err) => {});
  };
  const Status =
    props.Buildings.length > 0 ? <DisplayBuildings /> : <NoBuildings />;
  return (
    <>
      <AddBuildings></AddBuildings>
      {Status}
    </>
  );
};
const mapStateToProps = (state) => ({
  Buildings: state.Building.Buildings,
  banker: state.auth.banker,
});

export default connect(mapStateToProps, { fetchingBuildings })(Buildings);
